import styled from 'styled-components'
import Hero from './Hero'
import Content from './Content'
import ImagesProvider from './providers/ImagesProvider'
import Images from './Images'
import useInitializer from './hooks/useInitializer'
import Navigation from './components/Navigation'
import Recommendations from './components/Recommendations'
import RecommendationsLazyLoadWrapper from './components/RecommendationsLazyLoadWrapper'

const Main = () => {
  useInitializer()

  return (
    <>
      <Navigation />
      <Hero />
      <Content />
      <ImagesProvider>
        <ArtworkImagesContainer className='artwork-images bg-white'>
          <Images />
        </ArtworkImagesContainer>
      </ImagesProvider>
      <RecommendationsLazyLoadWrapper>
        <Recommendations />
      </RecommendationsLazyLoadWrapper>
    </>
  )
}

const ArtworkImagesContainer = styled.div`
  grid-area: images;
`

export default Main
